import { render, staticRenderFns } from "./bloglisting.vue?vue&type=template&id=6440c250&"
import script from "./bloglisting.vue?vue&type=script&lang=js&"
export * from "./bloglisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Articlecard: require('/opt/build/repo/components/articlecard.vue').default})
